export const iconFontAwesomeSecurityPeoplePulling = (
	<i className="fa-solid fa-people-pulling"></i>
);
